;(function () {
  'use strict'

  angular
    .module('contrast.ip')
    .controller('AddIPBlacklistCtrl', AddIPBlacklistCtrl)

  function AddIPBlacklistCtrl(
    $scope,
    $routeParams,
    IPBlacklistService,
    SubnetMaskService,
    IP_EXPIRATION_OPTIONS
  ) {
    'ngInject'

    var _today

    angular.extend($scope, {
      disabled: disabled,
      open: open,
      checkName: checkName,
      calculateRange: calculateRange,
      saveAddress: saveAddress,
      onCancel: onCancel
    })

    function init() {
      _initDefaults()
    }

    function _initDefaults() {
      _today = new Date()

      angular.extend($scope, {
        model: {
          blacklist: !IPBlacklistService.isTrusted(),
          expirationOps: IP_EXPIRATION_OPTIONS
        },
        validation: {
          unique: true
        },
        dateOption: {
          formatYear: 'yy',
          startingDay: 1
        },
        settings: {},
        minDate: _today,
        address: { expiration: 1, ip: $routeParams.sourceIp },
        range: {}
      })

      if ($scope.address.ip) {
        calculateRange()
      }
    }

    function disabled(date) {
      return date < _today
    }

    function open($event) {
      $event.preventDefault()
      $event.stopPropagation()
      $scope.opened = true
    }

    function checkName() {
      if (
        !angular.isUndefined($scope.address.name) &&
        $scope.address.name.length > 0
      ) {
        IPBlacklistService.checkName($scope.address.name)
          .then(function () {
            $scope.validation.unique = true
          })
          .catch(function () {
            $scope.validation.unique = false
          })
      } else {
        $scope.validation.unique = true
      }
    }

    function calculateRange() {
      $scope.range = SubnetMaskService.calculateRange($scope.address.ip)
    }

    function saveAddress() {
      angular.extend($scope.settings, {
        ip: $scope.address.ip,
        name: $scope.address.name,
        expiration: $scope.address.expiration,
        expiration_time: $scope.address.expiration_time,
        trusted: IPBlacklistService.isTrusted()
      })

      return IPBlacklistService.addAddress($scope.settings).then(
        IPBlacklistService.routeToIpGrid
      )
    }

    function onCancel() {
      IPBlacklistService.routeToIpGrid()
    }

    init()
  }
})()
